import styled from 'styled-components';

export const CardElementWrapper = styled.div`
  height: 40px;
  border: 1px solid #afafaf;
  border-radius: 3px;
  padding: 12px;
  margin-bottom: 16px;
`;
